import React from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { FormattedMessage, useIntl } from 'react-intl';
import { InputGroupAddon, Label } from 'reactstrap';
import PropTypes from 'prop-types';

const TaxInhouseField = ({ object, ...props }) => {
  const tax = useIntl().formatNumber(object?.taxInhouse || 0, {
    format: 'priceDecimal',
  });

  return (
    <AvGroup className="form-label-group input-group input-group-merge">
      <FormattedMessage id="taxInhouse">
        {(placeholder) => (
          <AvInput
            id={object?.id}
            type="text"
            name="taxInhouse"
            placeholder={placeholder}
            value={tax}
            // hint: validate gets the value from valueParser and validates it then
            validate={{ number: true }}
            valueParser={(value) => {
              const regex = /^[0-9]+((\,|\.)[0-9]{1,2})?$/;
              if (regex.test(value)) {
                const parsedValue = parseFloat(value.replace(',', '.'));
                return parsedValue >= 0 && parsedValue <= 100
                  ? parsedValue
                  : {}; // {} is definitely not a number
              } else {
                return {}; // {} is definitely not a number
              }
            }}
            {...props}
          />
        )}
      </FormattedMessage>
      <Label for={object?.id}>
        <FormattedMessage id="taxInhouse" />
      </Label>
      <InputGroupAddon addonType="append">%</InputGroupAddon>
    </AvGroup>
  );
};

TaxInhouseField.propTypes = {
  object: PropTypes.object,
};

export default TaxInhouseField;
